var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('h2',[_vm._v("Copyright © 2018-2021 www.power.com All Rights Reserved.")])])}]

export { render, staticRenderFns }